<template>
  <div>
      <div class="animated fadeIn">
      <div class="row">
        <div class="col-sm-12">
          <div class="card">
            <div class="card-header">
              <div class="title_head">
                <div class="col-sm-10">
                 I2OC Plan  
                  <button v-if="1===0" type="button" class="btn btn-sm btn-primary label_bttn" @click.prevent="addplan()"><i class="fa fa-plus"></i> Add Plan</button>
                </div>
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-sm-12">
                  <div v-if="message.success !== ''" class="alert alert-success">
                    <center>{{ message.success }}</center>
                  </div>
                  <div v-if="message.fail !== ''" class="alert alert-danger" style="color:#242020">
                    <center>{{ message.fail }}</center>
                  </div>
                </div>
              </div>
              <div class="table-responsive-sm">
                <vue-good-table
                  :columns="columns"
                  :rows="rows"
                  mode="remote"
                  ref="my-table"
                  :totalRows="totalRecords"
                  :sort-options="{enabled: true}"
                  :pagination-options="{ enabled: false}"
                  styleClass="vgt-table striped bordered table-sm condensed">
                <template slot="table-row" slot-scope="props">
                    <span v-if="props.column.field === 'type'">
                        <span v-if="props.row['type'] === 'plan_type'">
                           <span>Action</span>
                        </span>
                         <span v-else>
                            {{ props.formattedRow[props.column.field] }}
                        </span>
                    </span>
                    <span v-else-if="props.column.field === 'Free Basic'">
                        <span v-if="props.row.type === 'Shop Count'">
                            <span v-if="props.row['Free Basic'] === '0'">
                                <span>Unlimited</span>
                            </span>
                            <span v-else>
                                {{ props.formattedRow[props.column.field] }}        
                            </span>
                        </span>
                         <span v-else-if="props.row.type === 'User Count'">
                            <span v-if="props.row['Free Basic'] === '0'">
                                <span>Unlimited</span>
                            </span>
                            <span v-else>
                                {{ props.formattedRow[props.column.field] }}        
                            </span>
                        </span>
                        <span v-else-if="props.row.type === 'E-Commerce Integration'">
                            <span v-if="props.row['Free Basic'] === true">
                                <i class="fa fa-check" aria-hidden="true" style="color: green; font-size: 17px;"></i>
                            </span>
                            <span v-else>
                                <i class="fa fa-times" aria-hidden="true" style="color: red; font-size: 17px;"></i>
                            </span>
                        </span>
                         <span v-else-if="props.row.type === 'GST Report'">
                            <span v-if="props.row['Free Basic'] === true">
                                <i class="fa fa-check" aria-hidden="true" style="color: green; font-size: 17px;"></i>
                            </span>
                            <span v-else>
                                <i class="fa fa-times" aria-hidden="true" style="color: red; font-size: 17px;"></i>
                            </span>
                        </span>
                        <span v-else-if="props.row.type === 'Report'">
                            <span v-if="props.row['Free Basic'] === true">
                                <i class="fa fa-check" aria-hidden="true" style="color: green; font-size: 17px;"></i>
                            </span>
                            <span v-else>
                                <i class="fa fa-times" aria-hidden="true" style="color: red; font-size: 17px;"></i>
                            </span>
                        </span>
                        <!-- <span v-else-if="props.row.type === 'Balance Payment'">
                            <span v-if="props.row['Free Basic'] === true">
                                <i class="fa fa-check" aria-hidden="true" style="color: green; font-size: 17px;"></i>
                            </span>
                            <span v-else>
                                <i class="fa fa-times" aria-hidden="true" style="color: red; font-size: 17px;"></i>
                            </span>
                        </span> -->
                        <span v-else-if="props.row.type === 'Sales'">
                            <span v-if="props.row['Free Basic'] === true">
                                <i class="fa fa-check" aria-hidden="true" style="color: green; font-size: 17px;"></i>
                            </span>
                            <span v-else>
                                <i class="fa fa-times" aria-hidden="true" style="color: red; font-size: 17px;"></i>
                            </span>
                        </span>
                        <span v-else-if="props.row.type === 'Purchase'">
                            <span v-if="props.row['Free Basic'] === true">
                                <i class="fa fa-check" aria-hidden="true" style="color: green; font-size: 17px;"></i>
                            </span>
                            <span v-else>
                                <i class="fa fa-times" aria-hidden="true" style="color: red; font-size: 17px;"></i>
                            </span>
                        </span>
                        <span v-else-if="props.row.type === 'Barcode'">
                            <span v-if="props.row['Free Basic'] === true">
                                <i class="fa fa-check" aria-hidden="true" style="color: green; font-size: 17px;"></i>
                            </span>
                            <span v-else>
                                <i class="fa fa-times" aria-hidden="true" style="color: red; font-size: 17px;"></i>
                            </span>
                        </span>
                        <span v-else-if="props.row.type === 'Invoice'">
                            <span v-if="props.row['Free Basic'] === true">
                                <i class="fa fa-check" aria-hidden="true" style="color: green; font-size: 17px;"></i>
                            </span>
                            <span v-else>
                                <i class="fa fa-times" aria-hidden="true" style="color: red; font-size: 17px;"></i>
                            </span>
                        </span>
                        <span v-else-if="props.row.type === 'Category Count'">
                            <span v-if="props.row['Free Basic'] === '0'">
                                <span>Unlimited</span>
                            </span>
                            <span v-else>
                                {{ props.formattedRow[props.column.field] }}        
                            </span>
                        </span>
                        <span v-else-if="props.row.type === 'Product Count'">
                            <span v-if="props.row['Free Basic'] === '0'">
                                <span>Unlimited</span>
                            </span>
                            <span v-else>
                                {{ props.formattedRow[props.column.field] }}        
                            </span>
                        </span>
                         <span v-else-if="props.row.type === 'Customer Count'">
                            <span v-if="props.row['Free Basic'] === '0'">
                                <span>Unlimited</span>
                            </span>
                            <span v-else>
                                {{ props.formattedRow[props.column.field] }}        
                            </span>
                        </span>
                         <span v-else-if="props.row.type === 'Supplier Count'">
                            <span v-if="props.row['Free Basic'] === '0'">
                                <span>Unlimited</span>
                            </span>
                            <span v-else>
                                {{ props.formattedRow[props.column.field] }}        
                            </span>
                        </span>
                        <span v-else-if="props.row.type === 'Desktop Application'">
                            <span v-if="props.row['Free Basic'] === true">
                                <i class="fa fa-check" aria-hidden="true" style="color: green; font-size: 17px;"></i>
                            </span>
                            <span v-else>
                                <i class="fa fa-times" aria-hidden="true" style="color: red; font-size: 17px;"></i>
                            </span>
                        </span>
                        <span v-else-if="props.row.type === 'plan_type'">
                            <span v-if="props.row['Free Basic'] === '0'">
                                <button class="btn btn-sm btn-primary btn-pill" type="button" @click="edit_plan(props.row['Free Basic'])">Edit</button>
                            </span>
                        </span>
                         <span v-else>
                            {{ props.formattedRow[props.column.field] }}
                        </span>
                    </span>
                    <span v-else-if="props.column.field === 'Standard'">
                        <span v-if="props.row.type === 'Shop Count'">
                            <span v-if="props.row['Standard'] === '0'">
                                <span>Unlimited</span>
                            </span>
                            <span v-else>
                                {{ props.formattedRow[props.column.field] }}        
                            </span>
                        </span>
                         <span v-else-if="props.row.type === 'User Count'">
                            <span v-if="props.row['Standard'] === '0'">
                                <span>Unlimited</span>
                            </span>
                            <span v-else>
                                {{ props.formattedRow[props.column.field] }}        
                            </span>
                        </span>
                        <span v-else-if="props.row.type === 'E-Commerce Integration'">
                            <span v-if="props.row['Standard'] === true">
                                <i class="fa fa-check" aria-hidden="true" style="color: green; font-size: 17px;"></i>
                            </span>
                            <span v-else>
                                <i class="fa fa-times" aria-hidden="true" style="color: red; font-size: 17px;"></i>
                            </span>
                        </span>
                         <span v-else-if="props.row.type === 'GST Report'">
                            <span v-if="props.row['Standard'] === true">
                                <i class="fa fa-check" aria-hidden="true" style="color: green; font-size: 17px;"></i>
                            </span>
                            <span v-else>
                                <i class="fa fa-times" aria-hidden="true" style="color: red; font-size: 17px;"></i>
                            </span>
                        </span>
                        <span v-else-if="props.row.type === 'Report'">
                            <span v-if="props.row['Standard'] === true">
                                <i class="fa fa-check" aria-hidden="true" style="color: green; font-size: 17px;"></i>
                            </span>
                            <span v-else>
                                <i class="fa fa-times" aria-hidden="true" style="color: red; font-size: 17px;"></i>
                            </span>
                        </span>
                        <!-- <span v-else-if="props.row.type === 'Balance Payment'">
                            <span v-if="props.row['Standard'] === true">
                                <i class="fa fa-check" aria-hidden="true" style="color: green; font-size: 17px;"></i>
                            </span>
                            <span v-else>
                                <i class="fa fa-times" aria-hidden="true" style="color: red; font-size: 17px;"></i>
                            </span>
                        </span> -->
                        <span v-else-if="props.row.type === 'Sales'">
                            <span v-if="props.row['Standard'] === true">
                                <i class="fa fa-check" aria-hidden="true" style="color: green; font-size: 17px;"></i>
                            </span>
                            <span v-else>
                                <i class="fa fa-times" aria-hidden="true" style="color: red; font-size: 17px;"></i>
                            </span>
                        </span>
                        <span v-else-if="props.row.type === 'Purchase'">
                            <span v-if="props.row['Standard'] === true">
                                <i class="fa fa-check" aria-hidden="true" style="color: green; font-size: 17px;"></i>
                            </span>
                            <span v-else>
                                <i class="fa fa-times" aria-hidden="true" style="color: red; font-size: 17px;"></i>
                            </span>
                        </span>
                        <span v-else-if="props.row.type === 'Barcode'">
                            <span v-if="props.row['Standard'] === true">
                                <i class="fa fa-check" aria-hidden="true" style="color: green; font-size: 17px;"></i>
                            </span>
                            <span v-else>
                                <i class="fa fa-times" aria-hidden="true" style="color: red; font-size: 17px;"></i>
                            </span>
                        </span>
                        
                        <span v-else-if="props.row.type === 'Invoice'">
                            <span v-if="props.row['Standard'] === true">
                                <i class="fa fa-check" aria-hidden="true" style="color: green; font-size: 17px;"></i>
                            </span>
                            <span v-else>
                                <i class="fa fa-times" aria-hidden="true" style="color: red; font-size: 17px;"></i>
                            </span>
                        </span>
                        <span v-else-if="props.row.type === 'Category Count'">
                            <span v-if="props.row['Standard'] === '0'">
                                <span>Unlimited</span>
                            </span>
                            <span v-else>
                                {{ props.formattedRow[props.column.field] }}        
                            </span>
                        </span>
                        <span v-else-if="props.row.type === 'Product Count'">
                            <span v-if="props.row['Standard'] === '0'">
                                <span>Unlimited</span>
                            </span>
                            <span v-else>
                                {{ props.formattedRow[props.column.field] }}        
                            </span>
                        </span>
                         <span v-else-if="props.row.type === 'Customer Count'">
                            <span v-if="props.row['Standard'] === '0'">
                                <span>Unlimited</span>
                            </span>
                            <span v-else>
                                {{ props.formattedRow[props.column.field] }}        
                            </span>
                        </span>
                         <span v-else-if="props.row.type === 'Supplier Count'">
                            <span v-if="props.row['Standard'] === '0'">
                                <span>Unlimited</span>
                            </span>
                            <span v-else>
                                {{ props.formattedRow[props.column.field] }}        
                            </span>
                        </span>
                        <span v-else-if="props.row.type === 'Desktop Application'">
                            <span v-if="props.row['Standard'] === true">
                                <i class="fa fa-check" aria-hidden="true" style="color: green; font-size: 17px;"></i>
                            </span>
                            <span v-else>
                                <i class="fa fa-times" aria-hidden="true" style="color: red; font-size: 17px;"></i>
                            </span>
                        </span>
                        <span v-else-if="props.row.type === 'plan_type'">
                            <span v-if="props.row['Standard'] === '1'">
                                <button class="btn btn-sm btn-primary btn-pill" type="button" @click="edit_plan(props.row['Standard'])">Edit</button>
                            </span>
                        </span>
                         <span v-else>
                            {{ props.formattedRow[props.column.field] }}
                        </span>
                    </span>
                    <span v-else-if="props.column.field === 'Professional'">
                        <span v-if="props.row.type === 'Shop Count'">
                            <span v-if="props.row['Professional'] === '0'">
                                <span>Unlimited</span>
                            </span>
                            <span v-else>
                                {{ props.formattedRow[props.column.field] }}        
                            </span>
                        </span>
                         <span v-else-if="props.row.type === 'User Count'">
                            <span v-if="props.row['Professional'] === '0'">
                                <span>Unlimited</span>
                            </span>
                            <span v-else>
                                {{ props.formattedRow[props.column.field] }}        
                            </span>
                        </span>
                        <span v-else-if="props.row.type === 'E-Commerce Integration'">
                            <span v-if="props.row['Professional'] === true">
                                <i class="fa fa-check" aria-hidden="true" style="color: green; font-size: 17px;"></i>
                            </span>
                            <span v-else>
                                <i class="fa fa-times" aria-hidden="true" style="color: red; font-size: 17px;"></i>
                            </span>
                        </span>
                         <span v-else-if="props.row.type === 'GST Report'">
                            <span v-if="props.row['Professional'] === true">
                                <i class="fa fa-check" aria-hidden="true" style="color: green; font-size: 17px;"></i>
                            </span>
                            <span v-else>
                                <i class="fa fa-times" aria-hidden="true" style="color: red; font-size: 17px;"></i>
                            </span>
                        </span>
                        <span v-else-if="props.row.type === 'Report'">
                            <span v-if="props.row['Professional'] === true">
                                <i class="fa fa-check" aria-hidden="true" style="color: green; font-size: 17px;"></i>
                            </span>
                            <span v-else>
                                <i class="fa fa-times" aria-hidden="true" style="color: red; font-size: 17px;"></i>
                            </span>
                        </span>
                        <!-- <span v-else-if="props.row.type === 'Balance Payment'">
                            <span v-if="props.row['Professional'] === true">
                                <i class="fa fa-check" aria-hidden="true" style="color: green; font-size: 17px;"></i>
                            </span>
                            <span v-else>
                                <i class="fa fa-times" aria-hidden="true" style="color: red; font-size: 17px;"></i>
                            </span>
                        </span> -->
                        <span v-else-if="props.row.type === 'Sales'">
                            <span v-if="props.row['Professional'] === true">
                                <i class="fa fa-check" aria-hidden="true" style="color: green; font-size: 17px;"></i>
                            </span>
                            <span v-else>
                                <i class="fa fa-times" aria-hidden="true" style="color: red; font-size: 17px;"></i>
                            </span>
                        </span>
                        <span v-else-if="props.row.type === 'Purchase'">
                            <span v-if="props.row['Professional'] === true">
                                <i class="fa fa-check" aria-hidden="true" style="color: green; font-size: 17px;"></i>
                            </span>
                            <span v-else>
                                <i class="fa fa-times" aria-hidden="true" style="color: red; font-size: 17px;"></i>
                            </span>
                        </span>
                        <span v-else-if="props.row.type === 'Barcode'">
                            <span v-if="props.row['Professional'] === true">
                                <i class="fa fa-check" aria-hidden="true" style="color: green; font-size: 17px;"></i>
                            </span>
                            <span v-else>
                                <i class="fa fa-times" aria-hidden="true" style="color: red; font-size: 17px;"></i>
                            </span>
                        </span>
                        <span v-else-if="props.row.type === 'Invoice'">
                            <span v-if="props.row['Professional'] === true">
                                <i class="fa fa-check" aria-hidden="true" style="color: green; font-size: 17px;"></i>
                            </span>
                            <span v-else>
                                <i class="fa fa-times" aria-hidden="true" style="color: red; font-size: 17px;"></i>
                            </span>
                        </span>
                        <span v-else-if="props.row.type === 'Category Count'">
                            <span v-if="props.row['Professional'] === '0'">
                                <span>Unlimited</span>
                            </span>
                            <span v-else>
                                {{ props.formattedRow[props.column.field] }}        
                            </span>
                        </span>
                        <span v-else-if="props.row.type === 'Product Count'">
                            <span v-if="props.row['Professional'] === '0'">
                                <span>Unlimited</span>
                            </span>
                            <span v-else>
                                {{ props.formattedRow[props.column.field] }}        
                            </span>
                        </span>
                         <span v-else-if="props.row.type === 'Customer Count'">
                            <span v-if="props.row['Professional'] === '0'">
                                <span>Unlimited</span>
                            </span>
                            <span v-else>
                                {{ props.formattedRow[props.column.field] }}        
                            </span>
                        </span>
                         <span v-else-if="props.row.type === 'Supplier Count'">
                            <span v-if="props.row['Professional'] === '0'">
                                <span>Unlimited</span>
                            </span>
                            <span v-else>
                                {{ props.formattedRow[props.column.field] }}        
                            </span>
                        </span>
                        <span v-else-if="props.row.type === 'Desktop Application'">
                            <span v-if="props.row['Professional'] === true">
                                <i class="fa fa-check" aria-hidden="true" style="color: green; font-size: 17px;"></i>
                            </span>
                            <span v-else>
                                <i class="fa fa-times" aria-hidden="true" style="color: red; font-size: 17px;"></i>
                            </span>
                        </span>
                        <span v-else-if="props.row.type === 'plan_type'">
                            <span v-if="props.row['Professional'] === '2'">
                                <button class="btn btn-sm btn-primary btn-pill" type="button" @click="edit_plan(props.row['Professional'])">Edit</button>
                            </span>
                        </span>
                         <span v-else>
                            {{ props.formattedRow[props.column.field] }}
                        </span>
                        </span>
                        <span v-else-if="props.column.field === 'Premium'">
                        <span v-if="props.row.type === 'Shop Count'">
                            <span v-if="props.row['Premium'] === '0'">
                                <span>Unlimited</span>
                            </span>
                            <span v-else>
                                {{ props.formattedRow[props.column.field] }}        
                            </span>
                        </span>
                         <span v-else-if="props.row.type === 'User Count'">
                            <span v-if="props.row['Premium'] === '0'">
                                <span>Unlimited</span>
                            </span>
                            <span v-else>
                                {{ props.formattedRow[props.column.field] }}        
                            </span>
                        </span>
                        <span v-else-if="props.row.type === 'E-Commerce Integration'">
                            <span v-if="props.row['Premium'] === true">
                                <i class="fa fa-check" aria-hidden="true" style="color: green; font-size: 17px;"></i>
                            </span>
                            <span v-else>
                                <i class="fa fa-times" aria-hidden="true" style="color: red; font-size: 17px;"></i>
                            </span>
                        </span>
                         <span v-else-if="props.row.type === 'GST Report'">
                            <span v-if="props.row['Premium'] === true">
                                <i class="fa fa-check" aria-hidden="true" style="color: green; font-size: 17px;"></i>
                            </span>
                            <span v-else>
                                <i class="fa fa-times" aria-hidden="true" style="color: red; font-size: 17px;"></i>
                            </span>
                        </span>
                        <span v-else-if="props.row.type === 'Report'">
                            <span v-if="props.row['Premium'] === true">
                                <i class="fa fa-check" aria-hidden="true" style="color: green; font-size: 17px;"></i>
                            </span>
                            <span v-else>
                                <i class="fa fa-times" aria-hidden="true" style="color: red; font-size: 17px;"></i>
                            </span>
                        </span>
                        <!-- <span v-else-if="props.row.type === 'Balance Payment'">
                            <span v-if="props.row['Premium'] === true">
                                <i class="fa fa-check" aria-hidden="true" style="color: green; font-size: 17px;"></i>
                            </span>
                            <span v-else>
                                <i class="fa fa-times" aria-hidden="true" style="color: red; font-size: 17px;"></i>
                            </span>
                        </span> -->
                        <span v-else-if="props.row.type === 'Sales'">
                            <span v-if="props.row['Premium'] === true">
                                <i class="fa fa-check" aria-hidden="true" style="color: green; font-size: 17px;"></i>
                            </span>
                            <span v-else>
                                <i class="fa fa-times" aria-hidden="true" style="color: red; font-size: 17px;"></i>
                            </span>
                        </span>
                        <span v-else-if="props.row.type === 'Purchase'">
                            <span v-if="props.row['Premium'] === true">
                                <i class="fa fa-check" aria-hidden="true" style="color: green; font-size: 17px;"></i>
                            </span>
                            <span v-else>
                                <i class="fa fa-times" aria-hidden="true" style="color: red; font-size: 17px;"></i>
                            </span>
                        </span>
                        <span v-else-if="props.row.type === 'Barcode'">
                            <span v-if="props.row['Premium'] === true">
                                <i class="fa fa-check" aria-hidden="true" style="color: green; font-size: 17px;"></i>
                            </span>
                            <span v-else>
                                <i class="fa fa-times" aria-hidden="true" style="color: red; font-size: 17px;"></i>
                            </span>
                        </span>
                        <span v-else-if="props.row.type === 'Invoice'">
                            <span v-if="props.row['Premium'] === true">
                                <i class="fa fa-check" aria-hidden="true" style="color: green; font-size: 17px;"></i>
                            </span>
                            <span v-else>
                                <i class="fa fa-times" aria-hidden="true" style="color: red; font-size: 17px;"></i>
                            </span>
                        </span>
                        <!-- <span v-else-if="props.row.type === 'Invoice'">
                            <span v-if="props.row['Premium'] === '0'">
                                <span>Unlimited</span>
                            </span>
                            <span v-else>
                                {{ props.formattedRow[props.column.field] }}        
                            </span>
                        </span> -->
                        <span v-else-if="props.row.type === 'Category Count'">
                            <span v-if="props.row['Premium'] === '0'">
                                <span>Unlimited</span>
                            </span>
                            <span v-else>
                                {{ props.formattedRow[props.column.field] }}        
                            </span>
                        </span>
                        <span v-else-if="props.row.type === 'Product Count'">
                            <span v-if="props.row['Premium'] === '0'">
                                <span>Unlimited</span>
                            </span>
                            <span v-else>
                                {{ props.formattedRow[props.column.field] }}        
                            </span>
                        </span>
                         <span v-else-if="props.row.type === 'Customer Count'">
                            <span v-if="props.row['Premium'] === '0'">
                                <span>Unlimited</span>
                            </span>
                            <span v-else>
                                {{ props.formattedRow[props.column.field] }}        
                            </span>
                        </span>
                         <span v-else-if="props.row.type === 'Supplier Count'">
                            <span v-if="props.row['Premium'] === '0'">
                                <span>Unlimited</span>
                            </span>
                            <span v-else>
                                {{ props.formattedRow[props.column.field] }}        
                            </span>
                        </span>
                        <span v-else-if="props.row.type === 'Desktop Application'">
                            <span v-if="props.row['Premium'] === true">
                                <i class="fa fa-check" aria-hidden="true" style="color: green; font-size: 17px;"></i>
                            </span>
                            <span v-else>
                                <i class="fa fa-times" aria-hidden="true" style="color: red; font-size: 17px;"></i>
                            </span>
                        </span>
                        <span v-else-if="props.row.type === 'plan_type'">
                            <span v-if="props.row['Premium'] === '3'">
                                <button class="btn btn-sm btn-primary btn-pill" type="button" @click="edit_plan(props.row['Premium'])">Edit</button>
                            </span>
                        </span>
                         <span v-else>
                            {{ props.formattedRow[props.column.field] }}
                        </span>
                    </span>
                    <span v-else>
                        {{ props.formattedRow[props.column.field] }}
                    </span>
                </template>
                </vue-good-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal title="Edit Plan" no-close-on-esc no-close-on-backdrop class="modal-info" size="lg" hide-footer v-model="largeModal" @ok="largeModal = false">
    <b-row>
        <b-col sm="4">
        <div class="form-group">
            <label for="name">Plan Label<span style="color:red">*</span></label>
            <b-form-input type="text" ref="txtplanlabel" v-model="plan.plan_label" :class="{'is-invalid':hasErrors.plan_label}" disabled autocomplete="off"  placeholder="Enter Plan Label" ></b-form-input>
            <small class="form-text text-muted" v-if="hasErrors.plan_label" >Required</small>
        </div>
        </b-col>
        <b-col sm="4">
        <b-form-group>
            <label for="name">Shop Count<span class="star" style="color:red">*</span></label>
            <b-form-input type="text" ref="txtshopcount" v-model="plan.shop_count" :class="{'is-invalid':hasErrors.shop_count}" autocomplete="off"  placeholder="Enter Shop Count" ></b-form-input>
            <small class="form-text text-muted" v-if="hasErrors.shop_count" ></small>
        </b-form-group>
        </b-col>
        <b-col sm="4">
        <b-form-group>
            <label for="name">User Count<span class="star" style="color:red">*</span></label>
            <b-form-input type="text" v-model="plan.user_count" :class="{'is-invalid':hasErrors.user_count}" autocomplete="off" placeholder="Enter User Count"></b-form-input>
        <small  class="form-text text-muted" v-if="hasErrors.user_count" ><strong style="color: red;">Invalid</strong></small>
        </b-form-group>
        </b-col>            
    </b-row>
    <b-row>
        <b-col sm="4">
        <b-form-group>
            <label for="name">E-Commerce Integration</label>
            <b-form-select v-model="plan.ecom_int">          
                <option value="true">Allowed</option>
                <option value="false">Not Allowed</option>
            </b-form-select>
            <!-- <small class="form-text text-muted" v-if="hasErrors.shopad2" ><strong style="color: red;">Enter Valid Shop Address</strong></small> -->
        </b-form-group>
        </b-col>
        <b-col sm="4">
        <b-form-group>
           <label for="name">Invoice</label>
            <b-form-select v-model="plan.invoice">          
                <option value="true">Allowed</option>
                <option value="false">Not Allowed</option>
            </b-form-select>
        </b-form-group>
        </b-col>
        <b-col sm="4">
        <b-form-group>
            <label for="name">GST Report <span class="star" style="color:red">*</span></label>
           <b-form-select v-model="plan.gst_report">          
                <option value="true">Allowed</option>
                <option value="false">Not Allowed</option>
            </b-form-select>
        </b-form-group>
        </b-col>
    </b-row>
    <b-row>
        <b-col sm="4">
        <b-form-group>
            <label for="name">Report <span class="star" style="color:red">*</span></label>
            <b-form-select v-model="plan.report">          
                <option value="true">Allowed</option>
                <option value="false">Not Allowed</option>
            </b-form-select>
            <!-- <small class="form-text text-muted" v-if="hasErrors.gst_report" ><strong style="color: red;">Select State</strong></small> -->
        </b-form-group>
        </b-col>
        <b-col sm="4">
        <b-form-group>
            <label for="name">Desktop Application<span class="star" style="color:red">*</span></label>
            <b-form-select v-model="plan.desktop_app">          
                <option value="true">Allowed</option>
                <option value="false">Not Allowed</option>
            </b-form-select>
        </b-form-group>
        </b-col>
        <b-col sm="4">
        <b-form-group>
             <label for="name">Category Count<span class="star" style="color:red">*</span></label>
            <b-form-input type="text" v-model="plan.cat_count" :class="{'is-invalid':hasErrors.cat_count}" autocomplete="off"  placeholder="Category Count"></b-form-input>
            <small class="form-text text-muted" v-if="hasErrors.cat_count" ><strong style="color: red;">Invalid</strong></small>
        </b-form-group>
        </b-col>
    </b-row>
    <b-row>
        <b-col sm="4">
        <b-form-group>
            <label for="name">Product Count<span class="star" style="color:red">*</span></label>
            <b-form-input type="text" v-model="plan.prod_count" :class="{'is-invalid':hasErrors.prod_count}" autocomplete="off"  placeholder="Product Count"></b-form-input>
            <small class="form-text text-muted" v-if="hasErrors.prod_count" ><strong style="color: red;">Invalid</strong></small>
        </b-form-group>
        </b-col>
        <b-col sm="4">
        <b-form-group>
            <label for="name">Customer Count<span class="star" style="color:red">*</span></label>
            <b-form-input type="text" v-model="plan.cust_count" :class="{'is-invalid':hasErrors.cust_count}" autocomplete="off"  placeholder="Customer Count"></b-form-input>
            <small class="form-text text-muted" v-if="hasErrors.cust_count" ><strong style="color: red;">Invalid</strong></small>
        </b-form-group>
        </b-col>
        <b-col sm="4">
        <label for="name">Supplier Count<span class="star" style="color:red">*</span></label>
            <b-form-input type="text" v-model="plan.supp_count" :class="{'is-invalid':hasErrors.supp_count}" autocomplete="off"  placeholder="Supplier Count"></b-form-input>
            <small class="form-text text-muted" v-if="hasErrors.supp_count" ><strong style="color: red;">Invalid</strong></small>
        </b-col>
    </b-row>
    <b-row>
    <b-col sm="4">
        <b-form-group>
            <label for="name">Sales<span class="star" style="color:red">*</span></label>
           <b-form-select v-model="plan.sales">          
                <option value="true">Allowed</option>
                <option value="false">Not Allowed</option>
            </b-form-select>
        </b-form-group>
        </b-col>
        <b-col sm="4">
        <b-form-group>
            <label for="name">Purchase<span class="star" style="color:red">*</span></label>
           <b-form-select v-model="plan.purchase">          
                <option value="true">Allowed</option>
                <option value="false">Not Allowed</option>
            </b-form-select>
        </b-form-group>
        </b-col>
        <b-col sm="4">
        <label for="name">Barcode<span class="star" style="color:red">*</span></label>
           <b-form-select v-model="plan.barcode">          
                <option value="true">Allowed</option>
                <option value="false">Not Allowed</option>
            </b-form-select>
            <!-- <small class="form-text text-muted" v-if="hasErrors.barcode" ><strong style="color: red;">Invalid</strong></small> -->
        </b-col>
    </b-row>
    <b-row>
    <b-col sm="4">
        <b-form-group>
            <label for="name">Cost<span class="star" style="color:red">*</span></label>
            <b-form-input type="text" v-model="plan.cost" :class="{'is-invalid':hasErrors.cost}" autocomplete="off"  placeholder="Enter Plan Cost"></b-form-input>
            <small class="form-text text-muted" v-if="hasErrors.cost" ><strong style="color: red;">Invalid</strong></small>
        </b-form-group>
        </b-col>
         <b-col sm="8"></b-col>
    </b-row>
    <div class="card-footer modal_footer">
        <b-row>
        <b-col sm="12">
        <button type="submit" class="btn btn-sm btn-primary" @click.prevent="update()"><i class="fa fa-dot-circle-o"> </i> &nbsp;Update</button>
        </b-col>
        </b-row>
    </div>
    </b-modal>
    <Spinner v-if="loading"></Spinner>
  </div>
</template>
<script>
import Spinner from "../../spinner.vue";
export default {
  name: "PlanConfig",
  components: { Spinner },
  data() {
    return {
        edit_add: true,
        largeModal:false,
        plan_data:null,
        loading: false,
        totalRecords: 0,
        serverParams: {
            columnFilters: {},
            sort: {},
            page: 1,
            perPage: 50,
        },
        columns: [
            {
            label: "",
            field: "type",
            width: "20% !important",
            },
            {
            label: "Free Basic",
            field: "Free Basic",
            width: "20% !important",
            thClass: "text-center"
            },
            {
            label: "Standard",
            field: "Standard",
            width: "20% !important",
            thClass: "text-center"
            },
            {
            label: "Professional",
            field: "Professional",
            width: "20% !important",
            thClass: "text-center"
            },
            {
            label: "Premium",
            field: "Premium",
            width: "20% !important",
            thClass: "text-center"
            },
        ],
    rows: [],
    message: {
        success: "",
        fail: "",
    },
    hasErrors:{
        cost:'',
        barcode:false,
        purchase:false,
        sales:false,
        cust_count:false,
        supp_count:false,
        prod_count:false,
        cat_count:false,
        bal_payment:false,
        report:false,
        gst_report:false,
        invoice:false,
        ecom_int:false,
        user_count:false,
        shop_count:false,
        plan_label:false
    },
    plan:{
        cost:'',
        barcode:false,
        purchase:false,
        sales:false,
        cust_count:'0',
        supp_count:'0',
        prod_count:'0',
        cat_count:'0',
        // bal_payment:'0',
        report:'0',
        gst_report:false,
        invoice:false,
        desktop_app:false,
        ecom_int:false,
        user_count:'0',
        shop_count:'0',
        plan_label:'',
        plan_type:'0'
    }
    };
  },
  created() {
    this.getplan();
  },

  methods: {
    update(){
        this.plan.barcode = this.plan.barcode === "true" || this.plan.barcode === true? true : false
        this.plan.ecom_int = this.plan.ecom_int === "true" || this.plan.ecom_int === true? true : false
        this.plan.gst_report = this.plan.gst_report === "true" || this.plan.gst_report === true? true : false
        this.plan.report = this.plan.report === "true" || this.plan.report === true? true : false
        // this.plan.bal_payment = this.plan.bal_payment === "true" || this.plan.bal_payment === true? true : false
        this.plan.desktop_app = this.plan.desktop_app === "true" || this.plan.desktop_app === true? true : false
        this.plan.sales = this.plan.sales === "true" || this.plan.sales === true? true : false
        this.plan.purchase = this.plan.purchase === "true" || this.plan.purchase === true? true : false
        this.loading = true
        var _this = this
        if(this.edit_add === true){
             this.$http.post('/api/plans/update?where[plan_type]='+this.plan.plan_type,this.plan).then(function(response){
                _this.loading = false
                _this.largeModal=false
                if(parseInt(response.data.count) === 1){
                    _this.message.success = "Plan has been updated successfully"
                    setTimeout(function(){ _this.message.success= '';}, 2000);
                    _this.getplan();
                }
                else{
                    _this.message.fail = "Something went wrong, Please try again later"
                    setTimeout(function(){ _this.message.fail = '';}, 2000);
                }
            }).catch(function(error){
                _this.loading = false
                console.log(error)
            });
        }
       else{
           this.$http.post('/api/plans',this.plan).then(function(response){
                _this.loading = false
                _this.largeModal=false
                if(parseInt(response.data.count) === 1){
                    _this.message.success = "Plan has been added successfully"
                    setTimeout(function(){ _this.message.success= '';}, 2000);
                    _this.getplan();
                }
                else{
                    _this.message.fail = "Something went wrong, Please try again later"
                    setTimeout(function(){ _this.message.fail = '';}, 2000);
                }
            }).catch(function(error){
                _this.loading = false
                console.log(error)
            });
       }
    },

    addplan(){
        this.plan.cost = ''
        this.plan.cust_count = ''
        this.plan.supp_count = ''
        this.plan.prod_count = ''
        this.plan.cat_count = ''
        this.plan.invoice = ''
        this.plan.user_count = ''
        this.plan.shop_count = ''
        this.plan.barcode = false
        this.plan.ecom_int = false
        this.plan.gst_report = false
        this.plan.report = false
        this.plan.bal_payment = false
        this.plan.sales = false
        this.plan.purchase = false
        this.plan.plan_label = ''
        this.plan.plan_type = ''
        this.largeModal = true
        this.edit_add = false
    },

    add(){
        this.plan.barcode = this.plan.barcode === "true"? true : false
        this.plan.ecom_int = this.plan.ecom_int === "true"? true : false
        this.plan.gst_report = this.plan.gst_report === "true"? true : false
        this.plan.report = this.plan.report === "true"? true : false
        this.plan.bal_payment = this.plan.bal_payment === "true"? true : false
        this.plan.sales = this.plan.sales === "true"? true : false
        this.plan.purchase = this.plan.purchase === "true"? true : false
        this.loading = true
        var _this = this
        this.$http.post('/api/plans',this.plan).then(function(response){
            _this.loading = false
            _this.largeModal=false
            if(parseInt(response.data.count) === 1){
                _this.message.success = "Plan has been updated successfully"
                setTimeout(function(){ _this.message.success= '';}, 2000);
                _this.getplan();
            }
            else{
                _this.message.fail = "Something went wrong, Please try again later"
                setTimeout(function(){ _this.message.fail = '';}, 2000);
            }
        }).catch(function(error){
            _this.loading = false
            console.log(error)
        })
    },

    edit_plan(plan_type){
        // console.log(plan_type)
        this.edit_add = true
        for(var i=0;i<this.plan_data.length;i++){
            if(this.plan_data[i]['plan_type'] === plan_type){
                // console.log(this.plan_data[i])
                this.plan.plan_type = this.plan_data[i]['plan_type']
                this.plan.plan_label = this.plan_data[i]['plan_label']
                this.plan.shop_count = this.plan_data[i]['Shop Count']
                this.plan.user_count = this.plan_data[i]['User Count']
                this.plan.ecom_int = this.plan_data[i]['E-Commerce Integration']
                this.plan.invoice = this.plan_data[i]['Invoice']
                this.plan.gst_report = this.plan_data[i]['GST Report']
                this.plan.report = this.plan_data[i]['Report']
                this.plan.desktop_app = this.plan_data[i]['Desktop Application']
                // this.plan.bal_payment = this.plan_data[i]['Balance Payment']
                this.plan.cat_count = this.plan_data[i]['Category Count']
                this.plan.prod_count = this.plan_data[i]['Product Count']
                this.plan.cust_count = this.plan_data[i]['Customer Count']
                this.plan.supp_count = this.plan_data[i]['Supplier Count']
                this.plan.sales = this.plan_data[i]['Sales']
                this.plan.purchase = this.plan_data[i]['Purchase']
                this.plan.barcode = this.plan_data[i]['Barcode']
                this.plan.cost = this.plan_data[i]['Cost']
                // console.log(this.plan)
                break;
            }
        }
        this.largeModal = true
    },

    getplan() {
      var _this = this;
      this.rows.length = 0
      var create_row = []
      var dict = {}
      this.$http
        .get("/api/plans/getPlan")
        .then(function (response) {
            // console.log(response)
            _this.plan_data = response.data
            for (var i = 0; i < response.data.length; i++) {
                dict = response.data[i]
                Object.keys(dict).forEach((key,index) => {
                    var dict_key = {}
                    if(key !== 'plan_label'){
                        if(create_row.length > 0){
                            var exist = false
                            for(var k=0;k<create_row.length;k++){
                                if(create_row[k]['type'] === key){
                                    exist = true
                                    create_row[k][response.data[i]['plan_label']] = dict[key]
                                }
                                if(k === create_row.length - 1){
                                    if(exist === false){                                       
                                        dict_key[response.data[i]['plan_label']] = dict[key]
                                        dict_key['type'] = key
                                        create_row.push(dict_key)
                                    }
                                }    
                            }
                        }
                        else{
                            dict_key['type'] = key
                            dict_key[response.data[i]['plan_label']] = dict[key]
                            create_row.push(dict_key)
                        }
                    }
                });
                // create_row.push(dict)
            }   
            _this.rows = create_row
            // console.log(_this.rows)
        })
        .catch(function (error) {
            console.log(error);
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/admin_pages/plan_config.vue